import { render, staticRenderFns } from "./virtual-review-table.vue?vue&type=template&id=7803a7e4&scoped=true&"
import script from "./virtual-review-table.vue?vue&type=script&lang=js&"
export * from "./virtual-review-table.vue?vue&type=script&lang=js&"
import style0 from "./virtual-review-table.vue?vue&type=style&index=0&id=7803a7e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7803a7e4",
  null
  
)

export default component.exports